export default __webpack_public_path__ + "static/media/advanced-filters.5b67e986.svg";